module.exports = __webpack_public_path__ + "static/media/logo.1fa10cfe.png";


//////////////////
// WEBPACK FOOTER
// ./src/themes/irontrade/logo.png
// module id = 1234
// module chunks = 103